module.exports = __webpack_public_path__ + "static/media/note-site-2.84ef8726.png";